// import React from 'react';
// import { 
//   BookOpen, ShieldAlert, Award, FileText, 
//   ChevronLeft, Landmark, Scale, Search, 
//   HelpCircle, History 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function LegalResearchAndRegulations() {
  
//   // Core research and drafting service modules
//   const researchServices = [
//     {
//       title: "إعداد البحوث والدراسات النظامية",
//       desc: "تقديم دراسات قانونية معمقة ومقارنة (فقهية ونظامية) للقضايا والمسائل المعقدة، معززة بالأسانيد القضائية والتشريعية لدعم متخذي القرار والجهات الاستشارية.",
//       icon: <Search className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "صياغة اللوائح والأنظمة الداخلية",
//       desc: "تصميم وصياغة الأدلة الإجرائية، لوائح الحوكمة، تنظيمات العمل الداخلية، ومصفوفات الصلاحيات للشركات العائلية والمساهمة بما يتوافق مع أحدث الأنظمة السارية.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تحليل الأثر التشريعي ومواءمته",
//       desc: "تقييم أثر الأنظمة والقرارات الوزارية الحديثة الصادرة في المملكة على نماذج أعمال الشركات، وتقديم الحلول الاستباقية لتعديل الأوضاع القانونية للمنشآت.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "مشاريع الأنظمة وتطوير التشريعات",
//       desc: "المشاركة في إعداد ومراجعة مسودات الأنظمة واللوائح التنفيذية للجهات الحكومية والخاصة والقطاع الثالث، وفقاً لأفضل الممارسات والمعايير الدولية بصياغة قانونية رصينة.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="البحث القانوني والدراسات النظامية"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">التأصيل المعرفي والصياغة القانونية الرصينة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">إعداد البحوث والدراسات وصياغة اللوائح</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نجمع بين عمق البحث الفقهي ودقة التحليل النظامي الحديث لنوفر لعملائنا دراسات استباقية وصياغات تشريعية محكمة تؤمن مساراتهم الاستثمارية والقضائية وفق أحدث المعايير في المملكة.
//           </p>
//         </div>
//       </section>

//       {/* Analytical & Academic Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               القرار القانوني السديد يبدأ من الدراسة البحثية المعمقة
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               في ظل تسارع وتيرة التحديثات التشريعية في البيئة القانونية السعودية، فإن صياغة اللوائح الداخلية للشركات أو الدخول في نزاعات قضائية كبرى دون استناد إلى بحث نظامي مسبق وموثق يعد مجازفة غير محسوبة المخاطر.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               يضم مكتبنا فريقاً نخبوياً متخصصاً في البحث الأكاديمي والعملي، يتولى تتبع وتأصيل القوانين، وتحليل السوابق القضائية، واستخراج الدفوع والأسانيد الفقهية المبتكرة. نحن نضمن لشركتك تحويل النصوص النظامية الجافة إلى أطر وهياكل تشغيلية مرنة تحمي حقوق المنشأة وتدعم نموها المستدام.
//             </p>
//           </div>
          
//           {/* Why Structural Research Checklist Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <BookOpen className="w-5 h-5" /> القيمة الاستراتيجية للخدمة:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تحصين قرارات مجلس الإدارة بالأسانيد والآراء الفقهية المعتبرة.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>بناء لوائح تنظيمية خالية من الثغرات العقدية أو التشغيلية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الاستباقية المعرفية لمواجهة المخاطر الناتجة عن التغيرات التنظيمية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>تقديم مذكرات قانونية للمحاكم مصاغة بلغة تشريعية رفيعة المستوى.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Scope of Work */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">منظومة البحوث والصياغة التشريعية</h2>
//           <p className="text-gray-500">أدوات بحثية وصياغات متقنة تمنح منشأتك الحجة القانونية والامتثال التام</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {researchServices.map((service, index) => (
//             <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-amber-500 hover:shadow-md transition-all duration-300">
//               <div className="p-3 bg-slate-50 rounded-lg w-fit text-slate-700 mb-4">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-slate-800 mb-2">{service.title}</h3>
//               <p className="text-gray-500 text-sm leading-relaxed">{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Regulatory Context Warning */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <History className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">ملحوظة تنظيمية بشأن الأنظمة الأربعة الكبرى:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               مع صدور ودخول الأنظمة الكبرى حيز النفاذ في المملكة (نظام الإثبات، نظام الأحوال الشخصية، نظام المعاملات المدنية، والنظام الجزائي لتعزير العقوبات)، طرأت تغيرات جذرية على طريقة تفسير العقود والالتزامات والدفوع أمام المحاكم. لم يعد بالإمكان الاعتماد على الأدبيات القانونية القديمة؛ مما يجعل تحديث البحوث والمواءمة المستمرة للوائح حاجة حتمية لضمان سلامة مركزك القانوني.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Conversion Optimization */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <FileText className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تحتاج إلى دراسة قانونية موثقة أو صياغة لوائح لمنشأتك؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           يتولى خبراؤنا ومستشارونا الأكاديميون دراسة ملفك وإعداد البحوث التخصصية وصياغة الأنظمة الداخلية بأعلى درجات الاحترافية القانونية والموضوعية.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب إعداد دراسة بحثية أو صياغة لائحة
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  BookOpen, ShieldAlert, Award, FileText, 
  ChevronLeft, Landmark, Scale, Search, 
  HelpCircle, History 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function LegalResearchAndRegulations() {
  
  // Core research and drafting service modules - Refactored to Navy Light
  const researchServices = [
    {
      title: "إعداد البحوث والدراسات النظامية",
      desc: "تقديم دراسات قانونية معمقة ومقارنة (فقهية ونظامية) للقضايا والمسائل المعقدة، معززة بالأسانيد القضائية والتشريعية لدعم متخذي القرار والجهات الاستشارية.",
      icon: <Search className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "صياغة اللوائح والأنظمة الداخلية",
      desc: "تصميم وصياغة الأدلة الإجرائية، لوائح الحوكمة، تنظيمات العمل الداخلية، ومصفوفات الصلاحيات للشركات العائلية والمساهمة بما يتوافق مع أحدث الأنظمة السارية.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تحليل الأثر التشريعي ومواءمته",
      desc: "تقييم أثر الأنظمة والقرارات الوزارية الحديثة الصادرة في المملكة على نماذج أعمال الشركات، وتقديم الحلول الاستباقية لتعديل الأوضاع القانونية للمنشآت.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "مشاريع الأنظمة وتطوير التشريعات",
      desc: "المشاركة في إعداد ومراجعة مسودات الأنظمة واللوائح التنفيذية للجهات الحكومية والخاصة والقطاع الثالث، وفقاً لأفضل الممارسات والمعايير الدولية بصياغة قانونية رصينة.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="البحث القانوني والدراسات النظامية"
        description="نوفر لشركتكم التأصيل المعرفي والصياغة التشريعية المحكمة لمواكبة التحديثات النظامية في المملكة"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">التأصيل المعرفي والصياغة القانونية الرصينة</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">إعداد البحوث والدراسات وصياغة اللوائح</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نجمع بين عمق البحث الفقهي ودقة التحليل النظامي الحديث لنوفر لعملائنا دراسات استباقية وصياغات تشريعية محكمة تؤمن مساراتهم الاستثمارية والقضائية وفق أحدث المعايير في المملكة.
          </p>
        </div>
      </section>

      {/* Analytical & Academic Framework */}
  {/* Legal Research & Studies - Optimized Responsive Desktop Layout */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch">
          
          {/* Main Text Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              القرار القانوني السديد يبدأ من الدراسة البحثية المعمقة
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              في ظل تسارع وتيرة التحديثات التشريعية في البيئة القانونية السعودية، فإن صياغة اللوائح الداخلية للشركات أو الدخول في نزاعات قضائية كبرى دون استناد إلى بحث نظامي مسبق وموثق يعد مجازفة غير محسوبة المخاطر.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يضم مكتبنا فريقاً نخبوياً متخصصاً في البحث الأكاديمي والعملي، يتولى تتبع وتأصيل القوانين، وتحليل السوابق القضائية، واستخراج الدفوع والأسانيد الفقهية المبتكرة. نحن نضمن لشركتك تحويل النصوص النظامية الجافة إلى أطر وهياكل تشغيلية مرنة تحمي حقوق المنشأة وتدعم نموها المستدام.
            </p>
          </div>
          
          {/* Why Structural Research Checklist Box - Fixed Desktop Responsiveness */}
          <div className="w-full lg:w-96 lg:max-w-md shrink-0 bg-indigo-950 text-white p-8 rounded-xl border border-indigo-900/50 space-y-5 shadow-md flex flex-col justify-center">
            <h3 className="font-bold text-white text-base flex items-center gap-2 border-b border-white/10 pb-3">
              <BookOpen className="w-5 h-5 text-blue-400" /> القيمة الاستراتيجية للخدمة:
            </h3>
            <ul className="space-y-4 text-xs md:text-sm text-slate-200 font-light">
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>تحصين قرارات مجلس الإدارة بالأسانيد والآراء الفقهية المعتبرة.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>بناء لوائح تنظيمية خالية من الثغرات العقدية أو التشغيلية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>الاستباقية المعرفية لمواجهة المخاطر الناتجة عن التغيرات التنظيمية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>تقديم مذكرات قانونية للمحاكم مصاغة بلغة تشريعية رفيعة المستوى.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>

      {/* Grid: Scope of Work - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">منظومة البحوث والصياغة التشريعية</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">أدوات بحثية وصياغات متقنة تمنح منشأتك الحجة القانونية والامتثال التام</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {researchServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory Context Warning - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <History className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">ملحوظة تنظيمية بشأن الأنظمة الأربعة الكبرى:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              مع صدور ودخول الأنظمة الكبرى حيز النفاذ في المملكة (نظام الإثبات، نظام الأحوال الشخصية، نظام المعاملات المدنية، والنظام الجزائي لتعزير العقوبات)، طرأت تغيرات جذرية على طريقة تفسير العقود والالتزامات والدفوع أمام المحاكم. لم يعد بالإمكان الاعتماد على الأدبيات القانونية القديمة؛ مما يجعل تحديث البحوث والمواءمة المستمرة للوائح حاجة حتمية لضمان سلامة مركزك القانوني.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Conversion Optimization - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <FileText className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تحتاج إلى دراسة قانونية موثقة أو صياغة لوائح لمنشأتك؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          يتولى خبراؤنا ومستشارونا الأكاديميون دراسة ملفك وإعداد البحوث التخصصية وصياغة الأنظمة الداخلية بأعلى درجات الاحترافية القانونية والموضوعية.
        </p>


        <button 
  onClick={() => openWhatsApp( " طلب إعداد دراسة بحثية أو صياغة لائحة   ")}
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب إعداد دراسة بحثية أو صياغة لائحة
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}